import { PortfolioState } from '../../types/store/portfolio';

export const DESIRED_CLIENTS_COUNT = 5;

export function checkIfProductExists(state: PortfolioState, productName: string) {
  if (state.productTypes.find(p => p.name.toLowerCase() === productName.toLowerCase())) {
    throw new Error('This product is already added');
  }
}
